import React from "react"
import { observer } from "mobx-react"
import { Route, Redirect } from "react-router-dom"
import shop from "shop/shop"

function RouteWithLogin( { layout, component, footer, location, ...rest } ) {
  const { session } = shop

  if ( !session && shop.config.login_wall ) {
    shop.setLocationAfterLogin( `${location.pathname}${location.search}` )
    return <Redirect to="/login"/>
  }

  if ( session && session.handId && !session.customer && session.handId !== "-1" ) {
    shop.setLocationAfterLogin( `${location.pathname}${location.search}` )
    return <Redirect to="/login/accounts/"/>
  }
  return (
    <Route {...rest} render={( props ) =>
      React.createElement( layout, props
        , React.createElement( component, props )
        , footer ? React.createElement( footer, props ) : null
      )
    }/>
  )
}

export default RouteWithLogin



// WEBPACK FOOTER //
// ./src/layout/RouteWithLogin.js